export enum LinkRelation {
    client = 'client',
    crm = 'crm',
    default = 'default',
}
